module.exports = __webpack_public_path__ + "img/icon29.93f2e82c.png";